/**
 * Sefelly sets the cookie in the browser.
  * @notInstrumented
 */
// eslint-disable-next-line custom-rules/require-single-object-param
export const setCookie = (cookie: string) => {
  // eslint-disable-next-line no-restricted-globals
  document.cookie = cookie;
};
